<template>
  <FieldValidation class="Field-cont DatePicker" :rules="rules">
    <FieldLabel
      v-if="label || icon"
      :for="inputId"
      :icon="icon"
      :label="label"
      :required="required" />
    <div class="Field">
      <Datetime
        :id="inputId"
        :auto="true"
        :flow="flow"
        :format="format"
        :maxDatetime="toISOString(maxDatetime)"
        :minDatetime="toISOString(minDatetime)"
        :minuteStep="15"
        :name="name"
        :type="type"
        :use12Hour="false"
        :value="dateString"
        :valueZone="timezone"
        :zone="timezone"
        @input="setDate" />
      <Icon class="clear" name="cross" role="button" @click="setDate(null)" />
    </div>
  </FieldValidation>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import { defaultLocale } from '@config'
import { randomElementId } from '@utils/strings'

Settings.defaultLocale = defaultLocale

export default {
  components: { Datetime },
  props: {
    flow: Array,
    icon: String,
    label: String,
    maxDatetime: [Date, String],
    minDatetime: [Date, String],
    name: String,
    required: Boolean,
    rules: String,
    type: { type: String, default: 'date' },
    value: [Date, String],
    zone: String,
  },
  data() {
    return {
      inputId: randomElementId(),
    }
  },
  computed: {
    format() {
      return {
        datetime: 'MMM dd, T',
        time: 'HH:mm',
      }[this.type] || 'yyyy MMM dd'
    },
    dateString() {
      if (!this.value) return ''
      if (typeof this.value === 'string') return this.value

      return this.value.toISOString()
    },
    timezone() {
      if (this.zone) return this.zone
      if (this.type === 'time') return 'local'

      return 'UTC'
    },
  },
  methods: {
    toISOString(date) {
      if (!date || typeof date === 'string') return date

      return date.toISOString()
    },
    setDate(dateString) {
      if (this.type === 'time') {
        this.$emit('update:value', dateString.slice(11, 19))
        return
      }

      const emittedDate = dateString
        ? new Date(dateString)
        : null

      this.$emit('update:value', emittedDate)
    },
  },
}
</script>

<style lang="scss">
.DatePicker {
  .Icon.clear {
    color: $danger;
    position: absolute;
    right: 0.6rem;
    top: 0.3rem;

    &:hover {
      color: $danger-light;
    }
  }

  .vdatetime-input {
    background: $white;
    border-color: $border-color;
    cursor: pointer;
    display: block;
    text-align: left;
    width: 100%;
  }
}
</style>
